window.initialize = function () {
	var myLatLng = new google.maps.LatLng(53.3003, -2.0828);

	var myOptions = {
		zoom: 16,
		center: myLatLng,
		mapTypeId: google.maps.MapTypeId.TERRAIN
	};

	var map = new google.maps.Map(
		document.getElementById('image_frame'),
		myOptions
	);

	setTimeout(
		function () {
			/* eslint-disable no-new */
			new google.maps.Marker({
				position: myLatLng,
				title: 'Cheshire Hunt Holiday Cottages',
				map: map,
				animation: google.maps.Animation.DROP
			});
		},
		1500
	);
};

if ($('#image_frame[data-map]').length) {
	$(function () {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://maps.google.co.uk/maps/api/js' + '?key=AIzaSyCyUjBlkVHYPbXMzMKpG36gaJNuYtaPBhI&callback=initialize';
		document.body.appendChild(script);
	});
}



//////////////////
// WEBPACK FOOTER
// ./src/httpdocs/root/static/js/modules/google-maps.js
// module id = 5
// module chunks = 0